import { InjectionToken } from '@angular/core';

export const GOOGLE_MAP_MARKER_DATA = new InjectionToken<any>('GOOGLE_MARKER_DATA');
